import { BaseStatementPagePath } from "app/core/workflow/page-path/statement-page-path/base-statement-page.path";

export class ConfirmNewPremiumComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return "statement/:statementId/confirm-premium-price";
  }
}
